import { parse } from 'query-string';
import { isNullOrUndefinedOrEmpty } from '../common';
export const parseQueryString = (search, settings) => {
    const query = parse(search);
    const formatQuery = {};
    settings.forEach((setting) => {
        const { defaultIndex, initial, name, options, selects, type } = setting;
        const queryValue = query[name];
        if (selects) {
            formatQuery[name] = selects.includes(queryValue)
                ? queryValue
                : selects[defaultIndex || 0];
        }
        else if (options) {
            formatQuery[name] =
                options.find((v) => v.value === queryValue) ||
                    options[defaultIndex || 0];
        }
        else if (type === 'string') {
            const defaultValue = initial || '';
            formatQuery[name] =
                typeof queryValue === 'string' ? queryValue : defaultValue;
        }
        else if (type === 'string_split') {
            const defaultValue = initial || [];
            const rawValue = typeof queryValue === 'string' ? queryValue : '';
            formatQuery[name] = rawValue.split(',') || defaultValue;
        }
        else if (type === 'integer') {
            const defaultValue = initial || null;
            const isNumber = typeof queryValue === 'string' &&
                !isNullOrUndefinedOrEmpty(queryValue) &&
                /^[\d]*$/.test(queryValue || '');
            formatQuery[name] = isNumber ? parseInt(queryValue, 10) : defaultValue;
        }
        else {
            formatQuery[name] = initial;
        }
    });
    return {
        formatQuery,
        query,
    };
};
export default parseQueryString;
